import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  AttachFileOutlined,
  ExpandLessOutlined,
  ExpandMoreOutlined,
} from "@mui/icons-material";
import SendOutlined from "@mui/icons-material/SendOutlined";
import ViewAgendaOutlined from "@mui/icons-material/ViewAgendaOutlined";

import isNil from "lodash/isNil";

import { useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import HtmlTextEditor from "../../../../components/inputs/HtmlTextEditor";
import SelectMultipleInput from "../../../../components/inputs/SelectMultipleInput";
import TextInput from "../../../../components/inputs/TextInput";
import Flx from "../../../../components/layout/Flx";
import TitledHeader from "../../../../components/layout/TitledHeader";
import ToggleTabSwitcher from "../../../../components/navigation/ToggleTabSwitcher";
import Txt from "../../../../components/typography/Txt";
import TitledCard from "../../../../components/ui/TitledCard";
import { loanDrilldownSidebarTypes } from "../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { useLoanTermsHook } from "../../../../hooks/useLoanTermsHook";
import { sidebarOpen } from "../../../../redux/reducers/sidebarReducer";
import TemplateSelector from "./components/TemplateSelector";
import { EMAIL_COMPOSER_ACTIVE_TEMPLATES } from "../../../../components/Email/templates/EMAIL_COMPOSER_ACTIVE_TEMPLATES";
import { isArray } from "lodash";
import EmailPreview from "../../../../components/Email/EmailPreview";
import {
  loanFetchedDataEmailTemplatesClear,
  loanFetchedDataEmailTemplatesSet,
} from "../../../../redux/reducers/loanFetchedDataReducer";

const slugify = (str = "") =>
  str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-");

const LOAN_INFO_TAB_TYPES = {
  COMPOSER: "Email Templates",
  // SENT: "Sent",
};

// // Extract all {Variable} tokens from a template string
// const extractTemplateVariables = (str = "") => {
//   const regex = /\{([^}]+)\}/g;
//   const vars = new Set();
//   let match;
//   while ((match = regex.exec(str)) !== null) {
//     // Skip conditional syntax like {if:...} {end_if}
//     const token = match[1];
//     if (!token.startsWith("if:") && token !== "end_if") {
//       vars.add(token);
//     }
//   }
//   return Array.from(vars);
// };

// // Replace {Variable} tokens with user-supplied values
// const resolveTemplateVariables = (str = "", values = {}) => {
//   return str.replace(/\{([^}]+)\}/g, (match, token) => {
//     if (token.startsWith("if:") || token === "end_if") return match;
//     return values[token] !== undefined ? values[token] : match;
//   });
// };

const LoanDrilldownCommunicationTab = () => {
  const navigate = useNavigate();
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const templateData = useSelector((state) => state.sidebar?.state);
  const location = useLocation();
  const emailTemplates = useSelector(
    (state) => state.loanFetchedData?.emailTemplates,
  );

  const { getEmailTemplateNames, sendEmailTemplate, previewEmailTemplate } =
    useLoanTermsHook();
  const theme = useTheme();
  const dispatch = useDispatch();
  // const [templates, setTemplates] = useState(null);
  const pathParts = location.pathname.split("/");
  const communicationIndex = pathParts.indexOf("communication");
  const communicationType = pathParts[communicationIndex + 1] || null;
  const [tab, setTab] = useState(LOAN_INFO_TAB_TYPES.COMPOSER);

  const templatess = useMemo(() => {
    return EMAIL_COMPOSER_ACTIVE_TEMPLATES.map((t) => ({
      ...t,
      slug: t.slug || slugify(t.templateName),
    }));
  }, []);

  // const activeTemplate = useMemo(() => {
  //   if (!communicationType) return null;
  //   return find(templates, (t) => t.slug === communicationType) || null;
  // }, [communicationType, templates]);

  const handleSelectTemplate = (template) => {
    if (!template) return;
    dispatch(
      sidebarOpen(
        loanDrilldownSidebarTypes.EMAIL_COMPOSER,
        { ...template },
        {},
      ),
    );
    // navigate(
    //   `/loan/${loanDrilldown?.loanNumber}/communication/${template.slug}`,
    // );
  };

  useEffect(() => {
    if (isNil(emailTemplates)) {
      getEmailTemplateNames({
        onSuccessFn: (d) => {
          const TEMP_NAME_MAP = {
            insurance_request: "Send Homeowners Insurance Request",
            insurance_quote_request: "Send Insurance Quote Request",
            title_request: "Send Title Request",
            title_order_request: "Send Title Order Request",
          };
          const templateList = d?.templateNames || d;
          const convertedToForm = templateList?.map((n) => {
            return {
              template_display_name: TEMP_NAME_MAP[n],
              name: n,
              description: `Description for ${n}`,
              subject: `Subject for ${n}`,
            };
          });
          dispatch(loanFetchedDataEmailTemplatesSet(convertedToForm));
          // setTemplates(convertedToForm || []);
        },
      });
    }
  }, []);

  return (
    <>
      <TitledHeader
        title={"Loan Communication"}
        sx={{ borderBottom: `1px solid ${theme.palette.divider}`, pb: 0.5 }}
      >
        <ToggleTabSwitcher
          value={tab}
          onChange={setTab}
          sx={{ mt: 1 }}
          tabs={Object.values(LOAN_INFO_TAB_TYPES)}
        />
      </TitledHeader>
      <Box sx={{ py: 2 }}>
        <Container maxWidth="md">
          <Flx gap={2}>
            <TitledCard
              sx={{ flexShrink: 0, flexBasis: "500px" }}
              title={"Select Email Template"}
              icon={<ViewAgendaOutlined />}
            >
              <TemplateSelector
                templates={emailTemplates}
                // activeTemplate={activeTemplate}
                activeRowKeyValue={templateData?.name}
                onSelect={handleSelectTemplate}
                allowSearch
              />
            </TitledCard>
          </Flx>
        </Container>

        {/* <Container maxWidth="lg">
          <Flx gap={2}>
            <TitledCard
              sx={{ flexShrink: 0, flexBasis: "500px" }}
              title={"Select Email Template"}
              icon={<ViewAgendaOutlined />}
            >
              <TemplateSelector
                templates={emailTemplates}
                // activeTemplate={activeTemplate}
                activeRowKeyValue={templateData?.name}
                onSelect={handleSelectTemplate}
                allowSearch
              />
            </TitledCard>
            <EmailPreview
              to={EX_SENT_PAYLOAD.toRecipients}
              subject={EX_SENT_PAYLOAD.subject}
              body={EX_SENT_PAYLOAD.body}
              sentDate={EX_SENT_PAYLOAD.sentDate}
            />
          </Flx>
        </Container> */}
      </Box>
    </>
  );
};
const EX_TEMPLATE_FETCH = {
  template_name: "title_request",
  subject: "Title Request - LQ27800",
  html_body:
    '<div>\n\t<p>Title Team,</p>\n\t<p>Please confirm receipt and provide E&amp;O, Wire Instructions, and CPL with our mortgagee and loan number within 24 hours of this request.</p>\n\t<p>\n\t\tWe are the Lender, <strong>N/A</strong> in the above referenced loan transaction.\n\t\tWe will need title commitment for the Subject Property showing N/A.\n\t\tIt must include 24 month Chain of Title, Judgement/Lien Search on entity and guarantors for the county and state of both the property and entity, and OFAC Search.\n\t</p>\n\t<p>\n\t\tI will also need:<br>\n\t\t1. Commitment<br>\n\t\t2. A copy of the Deed - we must have the signed version as well<br>\n\t\t3. Prelim HUD\n\t</p>\n\n\t<h6 style="margin:12px 0 6px 0; font-size:12px; text-transform:uppercase; letter-spacing:.04em;">Loan Terms</h6>\n\t<ul>\n\t\t<li><strong>Mortgagee Clause:</strong> N/A</li>\n\t\t<li><strong>Expected Closing Date:</strong> 2026-03-04 21:34:29.042000</li>\n\t\t<li><strong>Loan Program:</strong> DSCR</li>\n\t\t<li><strong>Transaction Type:</strong> Purchase</li>\n\t\t<li><strong>Loan Number:</strong> LQ27800</li>\n\t\t<li><strong>Total Loan Amount:</strong> 500000.0</li>\n\t\t<li><strong>Interest Rate:</strong> 0.0</li>\n\t\t<li><strong>Borrowing Entity Name:</strong> TBD</li>\n\t\t<li><strong>Flood Zone:</strong> N/A</li>\n\t</ul>\n\n\t<h6 style="margin:12px 0 6px 0; font-size:12px; text-transform:uppercase; letter-spacing:.04em;">Subject Properties</h6>\n\t<ul>\n\t\t\n\t\t<li>\n\t\t\t<div><strong>Property Address:</strong> 125 Carley Avenue, Huntington, NY 11743</div>\n\t\t\t<div><strong>Property Type:</strong> Multifamily</div>\n\t\t</li>\n\t\t\n\t</ul>\n\n\t\n\t\n\t\n\t\n\t\n\t\n\n\t<h6 style="margin:12px 0 6px 0; font-size:12px; text-transform:uppercase; letter-spacing:.04em;">Guarantor</h6>\n\t<ul>\n\t\t<li><strong>Guarantor (1):</strong> N/A</li>\n\t\t<li><strong>Guarantor (1) Contact Information:</strong> N/A</li>\n\t</ul>\n\n\t<h6 style="margin:12px 0 6px 0; font-size:12px; text-transform:uppercase; letter-spacing:.04em;">Loan Team</h6>\n\t<ul>\n\t\t<li><strong>Loan Coordinator:</strong> N/A</li>\n\t\t<li><strong>Closer:</strong> N/A</li>\n\t\t<li><strong>Legal Lender Counsel:</strong> N/A</li>\n\t</ul>\n\n\t<h6 style="margin:12px 0 6px 0; font-size:12px; text-transform:uppercase; letter-spacing:.04em;">Title / Settlement Agent Contacts</h6>\n\t<ul>\n\t\t\n\t\t\n\t\t<li>\n\t\t\t<div><strong>Title Agent:</strong> Jimmy Oliva</div>\n\t\t\t<div><strong>Email:</strong> olivajames110@gmail.com</div>\n\t\t\t<div><strong>Phone:</strong> 6314563373</div>\n\t\t</li>\n\t\t\n\t\t\n\t\t\n\t\t\n\t</ul>\n\n\t<h6 style="margin:12px 0 6px 0; font-size:12px; text-transform:uppercase; letter-spacing:.04em;">Fees for Closing Statement / HUD Preparation</h6>\n\t<ul>\n\t\t\n\t\t\n\t\t\t\n\t\t\t\t\n\t\t\t\t<li>\n\t\t\t\t\t<strong>Per Diem Interest:</strong>\n\t\t\t\t\t\n\t\t\t\t\t\t0.0\n\t\t\t\t\t\n\t\t\t\t</li>\n\t\t\t\n\t\t\n\t\t\t\n\t\t\t\t\n\t\t\t\t<li>\n\t\t\t\t\t<strong>Origination Points:</strong>\n\t\t\t\t\t\n\t\t\t\t\t\t0.0\n\t\t\t\t\t\n\t\t\t\t</li>\n\t\t\t\n\t\t\n\t\t\n\t\t\n\t\t\n\n\t\t\n\t</ul>\n\n\t<p>Once we have these items our counsel will reach out if anything further is needed.</p>\n\t<p>Thank you,\n\t<br>Processing Team</p>\n</div>',
  text_body:
    "\nTitle Team,\nPlease confirm receipt and provide E&O, Wire Instructions, and CPL with our mortgagee and loan number within 24 hours of this request.\n\n\t\tWe are the Lender, N/A in the above referenced loan transaction.\n\t\tWe will need title commitment for the Subject Property showing N/A.\n\t\tIt must include 24 month Chain of Title, Judgement/Lien Search on entity and guarantors for the county and state of both the property and entity, and OFAC Search.\n\t\n\n\t\tI will also need:\n\t\t1. Commitment\n\t\t2. A copy of the Deed - we must have the signed version as well\n\t\t3. Prelim HUD\n\t\nLoan Terms\n\nMortgagee Clause: N/A\nExpected Closing Date: 2026-03-04 21:34:29.042000\nLoan Program: DSCR\nTransaction Type: Purchase\nLoan Number: LQ27800\nTotal Loan Amount: 500000.0\nInterest Rate: 0.0\nBorrowing Entity Name: TBD\nFlood Zone: N/A\n\nSubject Properties\n\n\nProperty Address: 125 Carley Avenue, Huntington, NY 11743\nProperty Type: Multifamily\n\n\nGuarantor\n\nGuarantor (1): N/A\nGuarantor (1) Contact Information: N/A\n\nLoan Team\n\nLoan Coordinator: N/A\nCloser: N/A\nLegal Lender Counsel: N/A\n\nTitle / Settlement Agent Contacts\n\n\nTitle Agent: Jimmy Oliva\nEmail: olivajames110@gmail.com\nPhone: 6314563373\n\n\nFees for Closing Statement / HUD Preparation\n\n\nPer Diem Interest:\n\t\t\t\t\t\n\t\t\t\t\t\t0.0\n\t\t\t\t\t\n\t\t\t\t\n\nOrigination Points:\n\t\t\t\t\t\n\t\t\t\t\t\t0.0\n\t\t\t\t\t\n\t\t\t\t\n\nOnce we have these items our counsel will reach out if anything further is needed.\nThank you,\n\tProcessing Team\n",
  sent_date_utc: "2026-03-04T16:27:24.296050+00:00",
};

const EX_SENT_PAYLOAD = {
  toRecipients: ["olivajames110@gmail.com"],
  ccRecipients: [],
  subject: "Insurance Request - LQ27800",
  body: '<p>Insurance Team, <strong>(Change)</strong></p><p>We would like to request an insurance policy for <strong>Dev Jimmy Test Loan - 1119</strong> for the <strong>Purchase</strong> transaction for the below list of properties. Please check both the "loss payee" and "mortgagee" clauses on the EOI. The projected closing date for the loan is <strong>2026-03-04 21:34:29.042000</strong>.</p><h6>List of Properties</h6><ul><li><p><strong>Property Address:</strong> 125 Carley Avenue, Huntington, NY 11743</p><p><strong>Property Type:</strong> Multifamily</p></li></ul><p></p><h6>Mortgagee Clause</h6><p>N/A ISAOA/ATIMA<br>290 Post Road West, Suite 100 Westport, CT 06880</p><p>--</p><h6>Loan Information</h6><ul><li><p><strong>Borrower Name:</strong> Dev Jimmy Test Loan - 1119</p></li><li><p><strong>Loan Program:</strong> DSCR</p></li><li><p><strong>Loan ID:</strong> LQ27800</p></li></ul><h6>Borrower Contact Information</h6><ul><li><p><strong>Name:</strong> Frankie Lindor</p><p><strong>Email:</strong> franklind@mets.com</p><p><strong>Phone Number:</strong> 5154234005</p><p><strong>Ownership:</strong> %</p></li><li><p><strong>Name:</strong> Juan Soto</p><p><strong>Email:</strong> jsoto@nym.org</p><p><strong>Phone Number:</strong> 5145512622</p><p><strong>Ownership:</strong> %</p></li></ul><h6>Disclaimers</h6><p>Purchase transactions may be delayed due to various circumstances. An insurance quote will be acceptable to verify costs and coverage, but an EOI and invoice will be required prior to closing.</p><p>Thank you,<br>Lendmarq Processing Team</p>',
  attachmentIds: [],
  contentType: "html",
};

export default LoanDrilldownCommunicationTab;
const EXAMPLE_LOAN_DRILLDOWN = {
  _id: "69714d356af1d8f4f922dff2",
  _property_totals: {
    annualFloodInsurance: 0,
    annualHoaFees: 234000,
    annualInsurance: 234000,
    annualOtherExpense: 0,
    annualPropertyMgmtFees: 0,
    annualTaxes: 234000,
    arv: 0,
    asIsValue: 2000000,
    assignmentFees: 0,
    constructionBudget: 0,
    costBasis: 1800000,
    interestReserves: 0,
    purchasePrice: 1800000,
    secondaryArv: 0,
    secondaryAsIsValue: 0,
  },
  baseLoanAmount: 500000,
  baseLoanToAsIsValue: 0.25,
  baseLoanToCost: 0.2777777777777778,
  baseLoanToPurchasePrice: 0.2777777777777778,
  borrowers: [
    {
      _id: "699622d9e639f3dc14fa59a8",
      borrowerGuidelineChecks: [],
      cashLiquidity: 0,
      citizenshipStatus: "US Citizen",
      createDateTime: "2026-02-17T18:32:31.362000",
      dateOfBirth: "1993-02-08T00:00:00",
      email_domain: "mets.com",
      email_lower: "franklind@mets.com",
      emailAddress: "franklind@mets.com",
      entityPercentOwnership: 0,
      estimatedFICO: "700-720",
      ff_retained_as_rental: {
        greater_than_three_years: 0,
        less_than_three_years: 0,
      },
      ff_sold: { greater_than_three_years: 0, less_than_three_years: 0 },
      ficoLow: 0,
      ficoMax: 0,
      ficoMid: 0,
      firstName: "Frankie",
      firstTimeHomebuyer: false,
      foreignNationalFlag: false,
      general_contractor_projects: {
        greater_than_three_years: 0,
        less_than_three_years: 0,
      },
      guc_retained_as_rental: {
        greater_than_three_years: 0,
        less_than_three_years: 0,
      },
      guc_sold: { greater_than_three_years: 0, less_than_three_years: 0 },
      hasExperienceWithFixFlips: true,
      hasExperienceWithGroundUpConstruction: false,
      hasExperienceWithIncomeProducingProperties: false,
      income_producing_properties: {
        greater_than_three_years: 0,
        less_than_three_years: 0,
      },
      isGuarantor: false,
      isPrimaryContactForLoan: false,
      lastName: "Lindor",
      maritalStatus: "Married",
      open_liens_judgments: false,
      otherLiquidity: 0,
      phone: "5154234005",
      primaryAddress: {
        city: "Villa Rica",
        coordinateTuple: [33.7307765, -84.9180941],
        country: "United States",
        countryCode: "US",
        county: "Carroll",
        fullAddress: "150 Main Street, Villa Rica, GA 30180",
        id: "TWRZPWuamY0UrBslPc20KA-1771446979123",
        latitude: 33.7307765,
        longitude: -84.9180941,
        score: 0.7638627059613388,
        state: "GA",
        streetAddress: "150 Main Street",
        streetName: "Main Street",
        streetNumber: "150",
        zip: "30180",
      },
      profileComplete: true,
      repeatBorrowerFlag: false,
      signUpDate: "2026-02-17T18:32:31.362000",
      totalLiquidity: 0,
      verifiedExperienceTotal: 0,
      verifiedLiquidity: 0,
    },
    {
      _id: "69714d356af1d8f4f922dff4",
      associations: { loanDocuments: ["696aa39af8e5c98a963ad5e8"] },
      borrowerGuidelineChecks: [],
      borrowerHasSSN: false,
      cashLiquidity: 0,
      citizenshipStatus: "Foreign National Non-Resident",
      company: "New York Mets",
      createDateTime: "2026-01-21T21:34:28.637000",
      dateOfBirth: "2026-02-26T00:00:00+00:00",
      email_domain: "nym.org",
      email_lower: "jsoto@nym.org",
      emailAddress: "jsoto@nym.org",
      entityPercentOwnership: 0,
      ficoLow: 0,
      ficoMax: 0,
      ficoMid: 0,
      firstName: "Juan",
      firstTimeHomebuyer: true,
      foreignNationalFlag: true,
      guc_sold: { greater_than_three_years: 0, less_than_three_years: 1 },
      hasExperienceWithFixFlips: false,
      hasExperienceWithGroundUpConstruction: true,
      hasExperienceWithIncomeProducingProperties: false,
      isGuarantor: false,
      isPrimaryContactForLoan: false,
      lastName: "Soto",
      maritalStatus: "Married",
      otherLiquidity: 0,
      phone: "5145512622",
      profileComplete: true,
      signUpDate: "2026-01-21T21:34:28.637000",
      totalLiquidity: 0,
      verifiedExperienceTotal: 0,
      verifiedLiquidity: 0,
    },
  ],
  closingMonth: "03-2026",
  closingQuarter: "2026Q1",
  closingWeek: "10-2026",
  createDateTime: "2026-01-21T22:03:33.224000",
  createdBy: "dev2@arrowservicing.com",
  createdFrom: "quickApp",
  createdFromLoanApp: "696aa39af8e5c98a963ad5e7",
  discountPoints: 0,
  dutchInterest: false,
  existingLoanInDefault: false,
  expectedClosingDate: "2026-03-04T21:34:29.042000",
  firstPaymentDate: "2026-05-01T00:00:00",
  foreignNationalIndicator: true,
  interestCalcType: "30/360",
  interestOnlyMonths: 0,
  interestRate: 0,
  isBalanceSheetClosing: false,
  isTableFunding: false,
  lastViewBy: "dev2@arrowservicing.com",
  lastViewDateTime: "2026-03-02T21:52:13.667000",
  loanDocuments: [
    {
      _id: "6998c15c0be9372c37dbb0fc",
      containerName: "69714d356af1d8f4f922dff2",
      content_type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      dealId: "69714d356af1d8f4f922dff2",
      docGroup: "Terms & Sizer",
      docType: "Sizer",
      documentStatus: "New Upload",
      file_display_name:
        "LQ RTL Sizer - 50 Deepwood Drive East Hartford CT 06118.xlsx",
      file_extension: "xlsx",
      file_name_as_loaded:
        "LQ RTL Sizer - 50 Deepwood Drive East Hartford CT 06118.xlsx",
      file_storage_name: "2fdcc2fa-0e99-11f1-bfae-728f0761ef6a.xlsx",
      isFinal: false,
      modifiedDate: "2026-02-20T20:17:32",
      name: "LQ RTL Sizer - 50 Deepwood Drive, East Hartford, CT 06118.xlsx",
      parsed: "False",
      searchIndexed: "False",
      size: 14052657,
      uploadDate: "2026-02-20T20:17:32.097710",
      uploadedBy: "dev2@arrowservicing.com",
    },
  ],
  loanName: "Dev Jimmy Test Loan - 1119",
  loanNumber: 1119,
  loanProductType: "DSCR",
  loanPurpose: "Purchase",
  loanStatus: "Processing",
  maturityDate: "2026-04-01T00:00:00",

  originationPoints: 0,
  outstandingLoanUpb: 0,
  permittedUsers: ["dev2@arrowservicing.com"],
  pipeline: "Underwriting",
  quickApplications: ["696aa39af8e5c98a963ad5e7"],
  salesforce_opportunity_id: "006VV00000X3D5mYAF",
  subjectProperties: [
    {
      _id: "69714d356af1d8f4f922dff3",
      address: {
        city: "Huntington",
        coordinateTuple: [40.866112, -73.43475],
        country: "United States",
        countryCode: "US",
        county: "Suffolk",
        fullAddress: "125 Carley Avenue, Huntington, NY 11743",
        id: "A-1yb5xFhzjCuSufdQxVXQ-1768596316056",
        latitude: 40.866112,
        longitude: -73.43475,
        score: 1,
        state: "NY",
        streetAddress: "125 Carley Avenue",
        streetName: "Carley Avenue",
        streetNumber: "125",
        zip: "11743",
      },
      annualHoaFees: 234000,
      annualInsurance: 234000,
      annualTaxes: 234000,
      asIsValue: 2000000,
      commercialUnitCount: 0,
      costBasis: 1800000,
      monthlyFloodInsurance: 0,
      monthlyHoaFees: 19500,
      monthlyInsurance: 19500,
      monthlyOtherExpense: 0,
      monthlyPropertyMgmtFees: 0,
      monthlyTaxes: 19500,
      propertyRuralIndicator: false,
      propertyType: "Multifamily",
      purchasePrice: 1800000,
      residentialUnitCount: 0,
      scopeOfWork: [],
      secondaryArvVariance: 0,
      secondaryAsIsVariance: 0,
      squareFootageChange: 0,
      unitCount: 0,
      units: [],
      vacantUnitCount: 0,
    },
  ],
  subStatus: "Appraisal In",
  sync_loan_id: "LQ27645",
  tags: ["dev"],
  termMonths: 0,
  totalAnnualFloodInsurance: 0,
  totalAnnualHoaFees: 234000,
  totalAnnualInsurance: 234000,
  totalAnnualOtherExpense: 0,
  totalAnnualPropertyMgmtFees: 0,
  totalAnnualTaxes: 234000,
  totalArv: 0,
  totalAsIsValue: 2000000,
  totalAssignmentFees: 0,
  totalConstructionBudget: 0,
  totalCostBasis: 1800000,
  totalHoldback: 0,
  totalInterestReserves: 0,
  totalLoanAmount: 500000,
  totalLoanToArv: 0,
  totalPurchasePrice: 1800000,
  totalSecondaryArv: 0,
  totalSecondaryAsIsValue: 0,
  updateBy: "dev2@arrowservicing.com",
  updateDatetime: "2026-02-18T20:39:43.414000",
  updateDateTime: "2026-02-25T22:57:08.558000",
  updateHistory: [],
  updateUser: "dev2@arrowservicing.com",
};
